import { memo } from "react";
import { Button } from "antd";
import IntlMessages from "components/Message/IntlMessages";
import MNC_LOGO from "assets/images/mc-logo.svg";
import KTB_LOGO from "assets/images/ktb-logo.svg";
import InformContainer from "components/InformContainer";
import useNavigateUserLanding from "components/hooks/useNavigateUserLanding";

const ErrorPage = () => {
  const { goHome } = useNavigateUserLanding();

  return (
    <InformContainer>
      <div className="logo-mnc">
        <picture className="d-flex justify-content-center">
          <div className="px-3 py-2">
            <img src={KTB_LOGO} alt="ktb logo" />
          </div>
          <div className="border-left px-3 py-2">
            <img src={MNC_LOGO} alt="mnc logo" />
          </div>
        </picture>
      </div>
      <div className="text-center py-4 h4">
        <IntlMessages id="error-page.please-message" />
      </div>
      <div className="text-center">
        <IntlMessages id="error-page.contact.call-center" />
        <div className="text-decoration-underline fw-bold">
          <IntlMessages id="error-page.contact.call-center.phone" />
        </div>
      </div>
      <div className="text-center mt-5">
        <Button className="btn button-ktb-main" onClick={goHome}>
          <IntlMessages id="global.goback.to.main" />
        </Button>
      </div>
    </InformContainer>
  );
};

export default memo(ErrorPage);
